import { get } from "lodash";
import { useUser } from "../../../context/UserContext";
import { DIGITAL_BROCHURE_SIZE_SKU } from "../../../helpers/printConstants";
import { useWatch } from "react-hook-form";

export const printType = (sku) => {
  if (sku.toString().startsWith("32")) return "brochure";
  if (sku.toString().startsWith("31")) return "rack_card";
  return false;
};

export const isBrochure = (sku) => printType(sku) === "brochure";
export const isRackCard = (sku) => printType(sku) === "rack_card";

export const usePrintTypeSkus = (type) => {
  const { user } = useUser();
  const print_product_skus = get(user, "print_product_skus", []);
  return print_product_skus.filter((sku) => type.includes(printType(sku)));
};
export const usePrintTypeValues = (type) => {
  const skus = usePrintTypeSkus(type);
  const note_type_sku = `print.${type}.type`;
  const watch_skus = [note_type_sku, ...skus];
  if (type === "digital_brochure") watch_skus.push(DIGITAL_BROCHURE_SIZE_SKU);
  const values = useWatch({ name: watch_skus });
  const notes_sku = `print.${type}.notes`;
  const required = !values.filter(Boolean).length;

  return { skus, note_type_sku, notes_sku, required };
};
